export const FILE_PROGRESS = 'FILE_PROGRESS';
